export default {
  title: "Онлайн каталог",
  tabs: {
    products: "Товарлор жана кызматтар",
    categories: "Категориялар",
  },
  buttons: {
    qrCode: "QR-код",
    create: "Жарат",
  },
  modals: {
    limit: {
      title: "Сиз тариф боюнча максималдуу сандагы товарларды жараттыңыз",
      subtitle: "Кошумча товар жараткыңыз келсе, тарифти көтөрүңүз.",
      cancel: "Жокко чыгаруу",
      toTariffs: "Тарифтерге",
    },
  },
  statuses: {
    allProducts: "Бардык товарлар",
    allCategories: "Бардык категориялар",
    confirmed: "Тастыкталган",
    moderation: "Модерацияда",
    rejected: "Кабыл алынган эмес",
    basic: "Негизги",
  },
  emptyState: {
    products: {
      noTradingPoints: {
        title: "Онлайн каталогдо товар жок",
        description:
          "Алгач соода нүктөсүн түзүңүз, андан кийин товарларды кошо аласыз",
        buttonText: "Соода нүктөлөрүнө",
      },
      noProducts: {
        title: "Онлайн каталогдо товар жок",
        buttonText: "Товар жарат",
      },
    },
    categories: {
      title: "Деректер жок",
      description:
        "Товар түзүлгөндөн кийин жана аны негизги категорияга тиркегенден кийин пайда болот. Же колдонуучу категориясын түзгөндөн кийин.",
      buttonText: "Категория түз",
    },
  },
  formErrors: {
    empty: "Өзгөрмө бош болбошу керек",
    price: "Маанини 0дөн чоң көрсөтүңүз",
    discount: "Маанини арзандатылган баадан төмөн көрсөтүңүз",
  },
  exitModal: {
    creating: {
      title: "Товар түзүүнү токтотуу?",
      subtitle:
        "Киргизилген маалыматтар сакталбайт. Өңдөөгө кайтуу үчүн «Артка» басыңыз.",
      backButton: "Артка",
      confirmButton: "Ооба, токтотуу",
    },
    editing: {
      title: "Киргизилген өзгөртүүлөрдү жок кылуу?",
      subtitle:
        "Эгер сактагыңыз келсе, артка кайтыңыз. Болбосо бардык өзгөртүүлөр сакталбайт. Товар карточкасында мурун сакталган маалыматтар көрүнөт.",
      backButton: "Сактап кайтуу",
      confirmButton: "Жок кылуу",
    },
  },
  categoryEditModal: {
    title: {
      rejected: "Категория модератор тарабынан кабыл алынган эмес",
      default: "Категория атын киргизиңиз",
    },
    subtitle: {
      rejected: "Атын өзгөртүп, категорияны модерацияга жөнөтүңүз.",
      rejectedWithMessage: "Атын өзгөртүп, категорияны модерацияга жөнөтүңүз.",
      default:
        "Категория жаңы товарларды түзүүдө тандоого жеткиликтүү болот жана RC PAYде модерациядан өткөндөн кийин көрсөтүлгөн ат менен көрүнөт.",
    },
    buttons: {
      cancel: "Жокко чыгаруу",
      sendForModeration: "Модерацияга жөнөтүү",
    },
    notification: {
      success: "Категория модерацияга жөнөтүлдү",
    },
  },
  categoryDeleteModal: {
    title: "Категория «{name}» жок кылууну каалайсызбы?",
    subtitle: "Ага тиешелүү товарлорго «Категория жок» негизги баа берилет",
    buttons: {
      cancel: "Жокко чыгаруу",
      delete: "Жок кылуу",
    },
    notification: {
      deleted: "Категория жок кылынды",
    },
  },
  productCard: {
    labels: {
      name: "Товар аты",
      category: "Категория",
      measurementUnit: "Өлчөө бирдиги",
      price: "Баасы, {currency}",
      discountPrice: "Арзандатылган баасы, {currency}",
      sku: "Артикул",
      barcode: "Штрихкод",
      description: "Сүрөттөө",
      tradingPointsVisibility: "Соода нүктөлөрүндө көрүнүшү",
      productImages: "Товар сүрөттөрү",
      showInCatalog: "Онлайн каталогдо көрсөтүү",
      showInCatalogDescription:
        "Товар модерациядан өткөндөн кийин RC PAYде тандалган соода нүктөлөрүндө онлайн каталогдо көрсөтүлөт.",
    },
    placeholders: {
      selectCategory: "Категорияны тандаңыз",
      selectMeasurementUnit: "Өлчөө бирдигин тандаңыз",
      sku: "30 белгиден көп эмес",
      selectTradingPoints: "Соода нүктөлөрүн тандаңыз",
    },
    buttons: {
      cancel: "Жокко чыгаруу",
    },
    notifications: {
      fillRequiredFields: "Бардык милдеттүү талааларды туура толтуруңуз",
    },
    moderationMessage: {
      title: "Модерациядан билдирүү",
    },
    measurementUnits: {
      none: "Өлчөө бирдиги жок",
    },
    imageRequirements: {
      aspectRatio: "Сүрөттүн катышы — 1:1",
      fileTypes:
        "JPEG, JPG, PNG — 5тен көп эмес файлдар, ар бири 10 МБден ашпашы керек",
    },
    imageCropper: {
      subtitle:
        "Тандалган аймак RC PAYде Онлайн каталогдо товар карточкасында көрсөтүлөт.",
    },
  },
  productsTableHeader: {
    columns: {
      name: "Аты",
      category: "Категория",
      price: "Баасы",
      status: "Статус",
    },
  },
  productsDeleteModal: {
    title: "Тандалган товарды жок кылууну каалайсызбы?",
    buttons: {
      cancel: "Жокко чыгаруу",
      delete: "Жок кылуу",
    },
  },
  productsQRModal: {
    title: "Меню үчүн QR-код",
    subtitle: "Онлайн каталог үчүн QR-кодду каалаган соода нүктөнү тандаңыз",
    tradingPoint: "Соода нүктөсү",
    downloadButton: "QR-код жүктөө",
  },
  productsSaveModal: {
    title: "Кээ бир өзгөртүүлөр модерацияны талап кылат",
    subtitle:
      "RC PAYде көрсөтүлгөн товар карточкасында алар модератор текшергенден кийин гана жаңыланат.",
    buttons: {
      cancel: "Жокко чыгаруу",
      sendForModeration: "Модерацияга жөнөтүү",
    },
  },
  productVisible: {
    messages: {
      visible: "RC PAYде көрсөтүлөт",
      hidden: "RC PAYде жашырылган",
    },
  },
  categoriesFilters: {
    sort: {
      newFirst: "Жаңы түзүлгөндөр биринчи",
      alphabeticalAsc: "Аты боюнча Адан Яга",
      alphabeticalDesc: "Аты боюнча Ядан Ага",
      productsCountAsc: "Аз товарлар биринчи",
      productsCountDesc: "Көп товарлар биринчи",
    },
    buttons: {
      create: "Жарат",
    },
    search: {
      placeholder: "Категория боюнча издөө",
    },
    status: {
      label: "Категория статусу",
    },
  },
  productFilters: {
    sort: {
      newFirst: "Жаңы түзүлгөндөр биринчи",
      alphabeticalAsc: "Аты боюнча Адан Яга",
      alphabeticalDesc: "Аты боюнча Ядан Ага",
      priceAsc: "Баасынын өсүшү боюнча",
      priceDesc: "Баасынын кемуусу боюнча",
    },
    buttons: {
      create: "Жарат",
    },
    search: {
      placeholder: "Издөө",
    },
    labels: {
      category: "Категория",
      tradingPoints: "Соода нүктөлөрү",
      status: "Статус",
    },
  },
  productDrawer: {
    title: {
      edit: "Товар жөнүндө маалымат",
      create: "Товар түзүү",
    },
    saveButton: {
      saveAndExit: "Сактап чыгып кетүү",
      sendForModeration: "Модерацияга жөнөтүү",
    },
    errors: {
      imageUpload:
        "Кээ бир сүрөттөрдү иштетүү мүмкүн болгон жок. Башка сүрөттөрдү жүктөп көрүңүз.",
    },
  },
  categoryGroup: {
    system: "Негизги",
    confirm: "Ырасталган",
    moderation: "Ченемде",
    reject: "Четке кагылды",
  },
  sysCategory: {
    autoLubrication: "Автомобиль майлоосу",
    autoDisks: "Автомобиль диски",
    autoOils: "Автомобиль мотор майлары",
    autoTires: "Автомобиль шиналары",
    carWash: "Автомойка",
    accumulator: "Аккумулятор",
    accessories: "Аксессуарлар",
    antifreeze: "Антифриз",
    rentMovableProperty: "Кыймылдуу мүлк ижарасы",
    rentImmovableProperty: "Кыймылсыз мүлк ижарасы",
    householdAppliances: "Үй техникасы",
    householdChemicals: "Үй-бүлөлүк химия",
    sideDishes: "Гарнирлер",
    gelSystems: "Гель системалары",
    hotDishes: "Ысык тамак ",
    grill: "Гриль",
    dysenfyingDetergents: "Дезинфекциялоочу жуугуч каражаттар",
    deserts: "Десерттер ",
    forChildren: "Балалар үчүн",
    forAnimals: "Айбандар үчүн ",
    forHoliday: "Майрам үчүн",
    homeTextiles: "Үй текстили",
    breakfast: "Эртең мененки тамак",
    snacks: "Таңгактар",
    spareParts: "Запас бөлүктөр",
    health: "Ден-соолук",
    toys: "Оюнчуктар",
    furnitureManufacturing: "Мейманкана жасао",
    medicals: "Медициналык максаттагы буюмдар",
    instruments: "Аспаптар",
    chancellery: "Канцелярия",
    books: "Китептер",
    laboratoryUtensils: "Лаборатория идиштери",
    furniture: "Мейманкана",
    medicalInstruments: "Медициналык аспаптар",
    medicalTechDevices: "Медициналык техникалык приборлор",
    perennialFlowers: "Көп жылдык гүлдөр",
    drinks: "Суусундуклар",
    equipment: "Жабдуулар",
    shoes: "Бут кийим",
    clothes: "Кийим",
    parfumeCosmetic: "Парфюмерия жана косметика",
    pasta: "Паста",
    pizza: "Пицца",
    gifts: "Белектер",
    printingProducts: "Полиграфиялык продукция",
    dishes: "Үй идиштери",
    products: "Продуктар",
    foodProducts: "Азык-түлүк",
    repairFinishingWork: "Ремонттук/жабдуу иштери",
    gardenFertilizers: "Бакча жер семирткичтери",
    seedlings: "Көчөттөр",
    salads: "Салаттар",
    sauces: "Соустар",
    sport: "Спорт",
    hairCareProducts: "Чач багуу каражаттары",
    buildingMaterials: "Курулуш материалдары",
    building: "Курулуш",
    soups: "Шорполор",
    gardenProducts: "Бакчачылык товарлары",
    brakeFluid: "Тормоз суюктугу",
    tosol: "Тосол",
    services: "Кызматтар",
    insuranceServices: "Камсыздандыруу кызматтары",
    care: "Кароо",
    filter: "Фильтр",
    fitnessLanch: "Фитнес таңғылык",
    photoProducts: "Фото товарлар",
    chemicalReagents: "Химиялык реактивдер",
    bread: "Нан",
    hobbies: "Хобби",
    flowers: "Гүлдөр",
    tireRepair: "Шина монтажы",
    ecoWashProducts: "Эко-тазалоочу каражаттар",
    electric: "Электроника",
    legalServices: "Юридикалык кызматтар",
    noCategory: "Категориясыз",
  },

  hideInRcPay: "{str}RC PAYден жашыруу",
  showInRcPay: "{str}RC PAYде көрсөтүү",
  removeProduct: "Товарды өчүрүү",
  checkProducts: "Товарларды кароо",
  changeNaming: "Атын өзгөртүү",
  removeCategory: "Категорияны өчүрүү",
  product: "Товар",
  message: {
    productHidden: "Товар RC PAYден жашырылды",
    productShown: "Товар RC PAYде көрсөтүлдү",
  },
  categoryName: "Категориянын аталышы",
  productsAmount: "Товарлардын саны",
  status: "Статус",
};
